import { render, staticRenderFns } from "./TournamentBuilder.vue?vue&type=template&id=4b802e48&"
import script from "./TournamentBuilder.vue?vue&type=script&lang=js&"
export * from "./TournamentBuilder.vue?vue&type=script&lang=js&"
import style0 from "./TournamentBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b802e48')) {
      api.createRecord('4b802e48', component.options)
    } else {
      api.reload('4b802e48', component.options)
    }
    module.hot.accept("./TournamentBuilder.vue?vue&type=template&id=4b802e48&", function () {
      api.rerender('4b802e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Tournament/TournamentBuilder.vue"
export default component.exports